import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { IReview } from "../../../models/reviews";

type IProps = Immutable<{
    review: IReview;
}>;

export const ReviewSource = (props: IProps): React.JSX.Element => {
    return (
        <div>
            <div className="customer-review__source-title">
                <strong>{t`Source:`}</strong>
            </div>
            {props.review.source_name}
        </div>
    );
};
